import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageTopicSprint({ topicId }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addTopicSprint(data = {}) {
    return privateFetch.post(`/v1/admin/topic/${topicId}/sprint`, data);
  }

  function updateTopicSprint({ sprintId, data }) {
    return privateFetch.put(`/v1/admin/topic/${topicId}/sprint/${sprintId}`, data);
  }

  function deleteTopicSprint({ sprintId } = {}) {
    return privateFetch.delete(`/v1/admin/topic/${topicId}/sprint/${sprintId}`);
  }

  function reOrderTopicSprint(data = {}) {
    return privateFetch.put(`/v1/admin/sprint/reorder`, data.data);
  }

  function manageTopicSprint(data) {
    if (data.type === 'UPDATE') {
      return updateTopicSprint(data);
    }

    if (data.type === 'DELETE') {
      return deleteTopicSprint(data);
    }

    if (data.type === 'REORDER') {
      return reOrderTopicSprint(data);
    }

    return addTopicSprint(data);
  }

  return useMutation(manageTopicSprint, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries(['list-sprints', topicId]);
    },
  });
}

export default useManageTopicSprint;
